export default __webpack_public_path__ + "static/media/global-site.b7ff90dd.webp";